

export const backendUrl: string = 'https://api-alisa-test.digitalberd.com'
// export const backendUrl: string = 'http://localhost:8013'
export const siteOrigin: string = backendUrl